module.exports = {"410811001":"东方红街道","410811002":"焦东街道","410811003":"百间房街道","410811004":"太行街道","410811005":"艺新街道","410811006":"光亚街道","410811007":"定和街道","410811008":"中星街道","410811009":"新城街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410811.json
// module id = 1465
// module chunks = 0